
/**
 * The modules registry
 */
export const registry = Object.create( null );